export const getFormattedDate = (date: string) => {
  const d = new Date(date);
  return (
    d.toLocaleDateString("en-US", { timeZone: "UTC", month: "long" }) +
    " " +
    d.toLocaleDateString("en-US", { timeZone: "UTC", day: "2-digit" }) +
    ", " +
    d.toLocaleDateString("en-US", { timeZone: "UTC", year: "numeric" })
  );
};

export const getSyncFormattedDate = (date: string) => {
  if (date != "") {
    const d = new Date(date);
    return (
      d.toLocaleDateString("en-US", {
        timeZone: "UTC",
        month: "short",
        day: "2-digit",
        year: "numeric",
      }) +
      " at " +
      d.toLocaleTimeString("en-US", {
        timeZone: "UTC",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      }) 
    );
  }
};

export const getTotalOrderAmountRow = (sku: any) => {
  if (!sku || sku === null) {
    return 0;
  }
  let totalAmount = 0;
  const quantity = sku.OrderQuantity || 0;
  const cost = sku.CostMetricCost || 0;
  const duration = sku.OrderInterval || 0;
  totalAmount += cost * quantity * duration;
  if (sku.SkuRelation && sku.SkuRelation.length > 0) {
    sku.SkuRelation.forEach((relation: any) => {
      const quantity = relation.OrderQuantity || 0;
      const cost = relation.CostMetricCost || 0;
      const duration = relation.OrderInterval || 0;
      totalAmount += cost * quantity * duration;
    });
  }
  return totalAmount;
};

export const getTotalOrderAmount = (order: any) => {
  let totalAmount = 0;
  if (!order || !order.Details || order.Details.length === 0) {
    return totalAmount.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  } else {
    order.Details.forEach((orderDetail: any) => {
      orderDetail.SkuDetails.forEach((sku: any) => {
        totalAmount += getTotalOrderAmountRow(sku);
      });
    });
    return totalAmount.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  }
};

export const onViewOrderItems = (orderId: number, orderDetails: any[]) => {
  const updatedOrderDetails = orderDetails.map((order: any) => {
    const isSelected = order.orderParentId === orderId;
    return {
      ...order,
      isExpanded: isSelected ? !order.isExpanded : false,
    };
  });
  return updatedOrderDetails;
};

export const handleCloseDetails = (orderId: number, orderDetails: any[]) => {
  const updatedOrderDetails = orderDetails.map((order: any) => {
    if (order.orderParentId === orderId) {
      return {
        ...order,
        isExpanded: !order.isExpanded,
      };
    }
    return order;
  });
  return updatedOrderDetails;
};

export type ArrowDirection = "up" | "down";

export const getArrowDirection = (
  orderId: number,
  orderDetails: any[],
): ArrowDirection => {
  const order = orderDetails.find(
    (order: any) => order.orderParentId === orderId,
  );
  return order && order.isExpanded ? "up" : "down";
};

export const getRetiredSkuListInWorkSpace = (orderList: any | null) => {
  const orderSkuErrorList: { [x: number]: string[] }[] = [];
  if (orderList === null) return [];

  orderList.forEach((orderData: any) => {
    const skuErrorList: string[] = [];
    orderData.Details.forEach((Detail: any) => {
      Detail.SkuDetails.forEach((sku: any) => {
        if (sku.StatusCd === "sku_retired") {
          skuErrorList.push(sku.SkuId);
        } else {
          return;
        }
        if (sku?.SkuRelation?.length > 0) {
          sku?.SkuRelation?.forEach((relation: any) => {
            if (relation.StatusCd === "sku_retired") {
              skuErrorList.push(relation.SkuId);
            } else {
              return;
            }
          });
        }
      });
    });
    if (skuErrorList.length === 0) {
      return;
    }
    const obj = {
      [orderData.OrderParentId]: skuErrorList,
    };
    orderSkuErrorList.push(obj);
  });
  return orderSkuErrorList;
};
